export const BLOCKCHAIN = (process.env.REACT_APP_BLOCKCHAIN ||
  'localhost') as keyof typeof NETWORKS;

export const LAUNCH_DATE =
  BLOCKCHAIN === 'mainnet'
    ? new Date('2022-03-20T17:00:00-08:00')
    : new Date('2022-01-31T15:41:00-08:00');

export const CONFIG = {
  localhost: {
    THE_GRAPH_GRAPHQL_URI: 'http://localhost:8000/subgraphs/name/globetro/lisamona',
    THE_GRAPH_SUBSCRIPTIONS_URI: 'ws://localhost:8001/subgraphs/name/globetro/lisamona',
  },
  rinkeby: {
    THE_GRAPH_GRAPHQL_URI: 'https://api.thegraph.com/subgraphs/name/lisamona-xyz/lisa-mona-rinkeby',
    THE_GRAPH_SUBSCRIPTIONS_URI:
      'wss://api.thegraph.com/subgraphs/name/lisamona-xyz/lisa-mona-rinkeby',
    SENTRY_URL: 'https://fd3ca448d7c04cfa9f23d9fde3a3f046@o1117646.ingest.sentry.io/6161634',
  },
  ropsten: {
    THE_GRAPH_GRAPHQL_URI: 'https://api.thegraph.com/subgraphs/name/lisamona-xyz/ropsten',
    THE_GRAPH_SUBSCRIPTIONS_URI: 'wss://api.thegraph.com/subgraphs/name/lisamona-xyz/ropsten',
  },
  mainnet: {
    SENTRY_URL: 'https://559fc24a821a43a1863d86c07bd7ca7a@o1117646.ingest.sentry.io/6151527',
    THE_GRAPH_GRAPHQL_URI: 'https://api.thegraph.com/subgraphs/name/lisamona-xyz/mainnet',
    THE_GRAPH_SUBSCRIPTIONS_URI: 'wss://api.thegraph.com/subgraphs/name/lisamona-xyz/mainnet',
  },
}[BLOCKCHAIN];

export const INFURA_ID = '0efa68fc0a4d4e7a8cb37a86baaecb6c';

export const ETHERSCAN_KEY = 'MPKZAJQPPSXZUJY41BPRDFIPWH5CWN6F8M';

export const ALCHEMY_KEY = 'ooJmW_8Wlzua5rJhgv1vipetkTMPQIC7';

export const BLOCKNATIVE_DAPPID = '46d90352-8260-46a9-aa4e-4bcdf9461450';

export const NETWORKS = {
  localhost: {
    name: 'localhost',
    color: '#666666',
    chainId: 31337,
    blockExplorer: '',
    rpcUrls: ['http://' + (global.window ? window.location.hostname : 'localhost') + ':8545'],
  },
  mainnet: {
    name: 'mainnet',
    color: '#ff8b9e',
    chainId: 1,
    blockExplorer: 'https://etherscan.io/',
    rpcUrls: [
      `wss://mainnet.infura.io/ws/v3/${INFURA_ID}`,
      `wss://eth-mainnet.alchemyapi.io/v2/${ALCHEMY_KEY}`,
    ],
  },
  ropsten: {
    name: 'ropsten',
    color: '#F60D09',
    chainId: 3,
    faucet: 'https://faucet.ropsten.be/',
    blockExplorer: 'https://ropsten.etherscan.io/',
    rpcUrls: [
      `wss://ropsten.infura.io/ws/v3/${INFURA_ID}`,
      'wss://eth-ropsten.alchemyapi.io/v2/sSMP65YfI_OPqINfy8Fp-Qf4JCAj8ue2',
    ],
  },
  rinkeby: {
    name: 'rinkeby',
    color: '#e0d068',
    chainId: 4,
    faucet: 'https://faucet.rinkeby.io/',
    blockExplorer: 'https://rinkeby.etherscan.io/',
    rpcUrls: ['https://eth-rinkeby.alchemyapi.io/v2/a8_EEb4dGwn086RmGa3dkBRMEO06d2nZ'],
  },
};

export const NETWORK = NETWORKS[BLOCKCHAIN];
